<template>
  <div style="min-height: 750px; font-size: 14px!important;" v-if="d_usrShpBundWdm">

    <b-row style="margin: 0px;">
      <b-col sm="12" lg="3">
        <b-row>
          <b-col sm="12" lg="12">
            <b-row style="margin-bottom: 10px;">
              <b-col sm="12" lg="6"> </b-col>
              <b-col sm="12" lg="6" style="text-align: right;">
                <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                  <template slot="button-content">
                    {{ StoreLangTranslation.data['process'][StoreLang] }}
                  </template>
                  <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'wdc_admin'])" @click="f_newWdcCampaign()"><i class="fa fa-plus"></i> {{ StoreLangTranslation.data['new_wdc_campaign'][StoreLang] }} </b-dropdown-item>
                  <!-- <b-dropdown-item v-if="d_userShopClientID && (ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id'))" @click="f_newWdcCampaign()"><i class="fa fa-plus"></i> {{ StoreLangTranslation.data['new_user_shop_bundle'][StoreLang] }} </b-dropdown-item> -->

                </b-dropdown>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <div style="overflow-x: hidden; overflow-y: auto; height: 750px;">
              <template v-if="d_loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </template>
              <template v-else>
                <b-row v-for="(wdmr_item, wdmr_item_ind) in d_usrWdcCampaignList" v-if="f_searchWdcCampaign(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="wdmr_item.client_id === d_userShopBundleClientID ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc; background-color: #fffac3;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'">

                  <b-col sm="12" lg="10">
                    <b-row @click="f_editThisWdcCampaign(wdmr_item.client_id)">
                      <b-col sm="12" lg="12">
                        <strong style="color: #0058ff;">
                          <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['lang'] && wdmr_item.data['0']['3']['lang'][StoreLang]">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['lang'][StoreLang] }}</span>
                          </template>
                          <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val']">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val'] }}</span>
                          </template>
                        </strong>
                      </b-col>
                    </b-row>
                    <b-row @click="f_editThisWdcCampaign(wdmr_item.client_id)">
                      <b-col sm="12" lg="3">
                        <i>
                          <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                          </template>
                        </i>
                        
                      </b-col>
                      <!-- <b-col sm="12" lg="9">
                        <span style="color: seagreen;">
                          <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['10'] && wdmr_item.data['0']['10']['lang'] && wdmr_item.data['0']['10']['lang'][StoreLang]">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['10']['lang'][StoreLang] }}</span>
                          </template>
                          <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['10'] && wdmr_item.data['0']['10']['val']">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['10']['val'] }}</span>
                          </template>
                        </span>
                      </b-col> -->
                    </b-row>
                  
                  </b-col>
                  <b-col sm="12" lg="2">
                    <!-- <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                      <template slot="button-content">
                      </template>
                      <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'wdc_admin']) || ClsUser.f_checkUserAuth([d_wdcCampaignClientID + '_shop_admin', d_wdcCampaignClientID + '_edit'], 'with_id')" @click="f_goToUserShopBundleDiscountListPage(wdmr_item.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['user_shop_discount_list'][StoreLang] }} </b-dropdown-item>
                      <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'wdc_admin']) || ClsUser.f_checkUserAuth([d_wdcCampaignClientID + '_shop_admin', d_wdcCampaignClientID + '_edit'], 'with_id')" @click="f_goToUserShopBundleAgreementListPage(wdmr_item.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['shop_bundle_agreement_list'][StoreLang] }} </b-dropdown-item>
                      <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'wdc_admin']) || ClsUser.f_checkUserAuth([d_wdcCampaignClientID + '_shop_admin', d_wdcCampaignClientID + '_edit'], 'with_id')" @click="f_agrementView(wdmr_item.client_id)"><i class="fa fa-sign-in"></i> {{ StoreLangTranslation.data['agreement_preview'][StoreLang] }} </b-dropdown-item>
                    </b-dropdown> -->
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="9">
        <b-tabs>

          <b-tab :active="d_selectedTab === 'wdc_campaign_record'" @click="d_selectedTab = 'wdc_campaign_record'">
            <template slot="title">
              {{ StoreLangTranslation.data['wdc_campaign_record'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'wdc_campaign_record'">
              <wdc-campaign-record v-if="d_componentShow" :p_wdcCampaignClientID="d_wdcCampaignClientID" :f_wdcCampaignList="f_wdcCampaignList"></wdc-campaign-record>
            </template>

          </b-tab>

          <b-tab v-if="d_wdcCampaignClientID" :active="d_selectedTab === 'wdc_campaign_customer_list'" @click="d_selectedTab = 'wdc_campaign_customer_list'">
            <template slot="title">
              {{ StoreLangTranslation.data['wdc_campaign_customer_list'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'wdc_campaign_customer_list'">
              <wdc-campaign-customer-list v-if="d_componentShow" :p_wdcCampaignClientID="d_wdcCampaignClientID"></wdc-campaign-customer-list>

            </template>
            
          </b-tab>

          <b-tab v-if="d_wdcCampaignClientID" :active="d_selectedTab === 'wdc_campaign_channel_design_list'" @click="d_selectedTab = 'wdc_campaign_channel_design_list'">
            <template slot="title">
              {{ StoreLangTranslation.data['wdc_campaign_channel_design_list'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'wdc_campaign_channel_design_list'">
              <wdc-campaign-channel-design-list v-if="d_componentShow" :p_wdcCampaignClientID="d_wdcCampaignClientID"></wdc-campaign-channel-design-list>

            </template>
            
          </b-tab>


          <!-- <b-tab v-if="d_wdcCampaignClientID" :active="d_selectedTab === 'bundle_discount_list'" @click="d_selectedTab = 'bundle_discount_list'">
            <template slot="title">
              {{ StoreLangTranslation.data['shop_bundle_discount_list'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'bundle_discount_list'">
              <shop-bundle-discount-list v-if="d_componentShow" :p_userShopClientID="d_userShopClientID" :p_wdcCampaignClientID="d_wdcCampaignClientID"></shop-bundle-discount-list>

            </template>
            
          </b-tab> -->




        </b-tabs>
      </b-col>
    </b-row>
    
    <!-- <b-modal v-if="d_agreementModal.show" id="d_agreementModal_show" v-model="d_agreementModal.show" scrollable hide-footer :title="StoreLangTranslation.data['agreement_preview'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <agreement-view :p_shopData="d_agreementModal.shop_data" :p_bundleData="d_agreementModal.bundle_data"></agreement-view>
          </b-col>
        </b-row>
      </p>
    </b-modal> -->
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as WdcCampaignChannelDesignList
} from '@/wam/components/wdc/WdcCampaignChannelDesignList';
import {
  default as WdcCampaignChannelDesignRecord
} from '@/wam/components/wdc/WdcCampaignChannelDesignRecord';
import {
  default as WdcCampaignCustomerList
} from '@/wam/components/wdc/WdcCampaignCustomerList';
import {
  default as WdcCampaignCustomerRecord
} from '@/wam/components/wdc/WdcCampaignCustomerRecord';
import {
  default as WdcCampaignRecord
} from '@/wam/components/wdc/WdcCampaignRecord';
import { mapGetters } from 'vuex';
export default {
  name: 'WdcCampaignManage',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    WdcCampaignChannelDesignList,
    WdcCampaignChannelDesignRecord,
    WdcCampaignCustomerList,
    WdcCampaignCustomerRecord,
    WdcCampaignRecord,
  },
  props: {
    
  },
  data () {
    return {
      d_loading: false,
      d_userShopBundleClientID: '',
      d_componentShow: false,
      d_selectedTab: 'wdc_campaign_record',
      d_agreementModal: {
        'show': false,
        'shop_data': {},
        'bundle_data': {},
      },
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_usrWdcCampaignList: [],
      d_usrShpBundWdm: '',
      ClsUser: ClsUser,
      d_wdcCampaignClientID: '',
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));

    let auth_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'wdc_admin']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && user_perm_eligibleGeneral) {
      this.f_wdcCampaignList();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
  },
  methods: {
    f_agrementView: function (user_shop_bundle_client_id) {
      this.d_agreementModal.shop_data = {'client_id': this.d_userShopClientID };
      this.d_agreementModal.bundle_data = {'client_id': user_shop_bundle_client_id, 'agreement_client_id': '' };
      this.d_agreementModal.show = true;
    },
    f_newWdcCampaign: function () {
      this.d_selectedTab = 'wdc_campaign_record';
      this.d_userShopBundleClientID = '';
      this.d_componentShow = false;
      setTimeout(function () {
        this.d_componentShow = true;
      }.bind(this), 100)
      // this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_record', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID} });
    },
    f_goToUserShopBundleProductListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_product_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_goToUserShopBundleDiscountListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_discount_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_goToUserShopBundleAgreementListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_agreement_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_editThisWdcCampaign: function (wdc_campaign_client_id) {
      this.d_wdcCampaignClientID = wdc_campaign_client_id;
      this.d_componentShow = false;
      setTimeout(function () {
        this.d_componentShow = true;
      }.bind(this), 100)

      // let route_path = ClsRoute.f_getRoutePath('user_shop_bundle_record', this.StoreLang);
      // // console.log('route_path : ', route_path);
      // this.$router.push({ path: route_path, query: { 'user_shop_bundle_client_id': user_shop_bundle_client_id, 'user_shop_client_id': this.d_userShopClientID } });
    },
    f_searchWdcCampaign: function (wdc_camp) {
      let res = false;
      if (this.d_searchText) {
        let search_item = '';
        try {
          search_item = wdc_camp.data['0']['3']['lang'][this.StoreLang];
        } catch(err) {}
        if (search_item) {
          if (search_item.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
            res = true;
          }
        }
      } else {
        res = true;
      }
      return res;
    },
    f_wdcCampaignList: function () {
      this.d_componentShow = false;
      this.d_loading = true;
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.wdc_campaign_list(query, data)
        .then(resp => {
          this.d_componentShow = true;
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_usrWdcCampaignList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
  }
};

</script>

